import { ReactNode } from "react";
import { useAuthContext } from "../auth/useAuthContext";
import { useCartContext } from "../cart/hooks/CartContext";
import { Navigate } from "react-router";
import { PATHS } from "src/routes/paths";
import LoadingScreen from "src/components/loading-screen";

interface Props {
  children: ReactNode
}

const PayGuard = ({ children }: Props) => {

  const { isAuthenticated, isInitialized } = useAuthContext();

  const {slug_id, shop_id, menu_id} = useCartContext();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!slug_id || !shop_id || !menu_id || !isAuthenticated) {
    return <Navigate to={PATHS.home.view('la-urbana-burguer-bar')} />;
  }

  return (
    <>{children}</>
  );
}

export default PayGuard;